// #region Imports
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import DetallesModal from "../../components/Common/DetallesModal"
import AltaEstudiante from "./AltaEstudiante"

// #region reactstrap
import {
  Container,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button,
} from "reactstrap"
// #endregion
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"

// #region  components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"
// #endregion

//redux
import { useDispatch } from "react-redux"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

//i18n
import { withTranslation } from "react-i18next"

// #endregion

// #region selectors
import {
  useControlEscolarAlumnos,
  useControlEscolarError,
  useControlEscolarIsLoading,
  useControlEscolarsListaIdStatus,
  useCampusVirtualIdCampus,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarListaAlumnos as onGetAlumnosList,
  SetCajaoAlumnoSelected as onSetCajaoAlumnoSelected,
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  setControlEscolarListaEstados as setsListaIdStatus,
} from "store/actions"
// #endregion

const Control_Escolar = props => {
  //meta title
  document.title = "Control Escolar | CampusVirtual"
  //
  // #region Init

  // #endregion

  // #region const-selectors
  const alumnos = useControlEscolarAlumnos()
  const error = useControlEscolarError()
  const isLoading = useControlEscolarIsLoading()
  const idCampus = useCampusVirtualIdCampus()
  const sListaIdStatus = useControlEscolarsListaIdStatus()
  // #endregion

  // #region useRef

  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States

  const [modal, setModal] = useState(false)
  const [showModalAltaEstudiante, setShowModalAltaEstudiante] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [job, setJob] = useState(null)
  const [oAlumno, setoAlumno] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)

  // #endregion

  // #region useEffects

  useEffect(() => {
    if (idCampus > 0) {
      if (sListaIdStatus?.length > 0 || null) {
        dispatch(
          onGetAlumnosList({
            nombreSolicitud: "listaalumnosxidcampusxlistastatus",
            idCampus: idCampus,
            sListaIdStatus: sListaIdStatus,
          })
        )
      } else {
        console.log(
          "useEffect::[dispatch, idCampus, sListaIdStatus]::sListaIdStatus: ",
          sListaIdStatus
        )
      }
    } else {
      console.log(
        "useEffect::[dispatch, idCampus, sListaIdStatus]::idCampus:",
        idCampus
      )
    }
  }, [dispatch, idCampus, sListaIdStatus])

  useEffect(() => {
    //console.log("useEffect::[sListaIdStatus]: ", sListaIdStatus)
  }, [sListaIdStatus])

  useEffect(() => {
    if (error && error.length) {
      // dispatch(
      //   onGetAlumnosList({
      //     nombreSolicitud: "listaalumnosxidcampusxlistastatus",
      //     idCampus: 5,
      //     sListaIdStatus: "1,4",
      //   })
      // )
      toast.error(error, {
        autoClose: 3000,
      })
    }
  }, [dispatch, error])

  // #endregion

  // #region functions

  const toggle = () => {
    if (modal) {
      setModal(false)
      setJob(null)
    } else {
      setModal(true)
    }
  }

  const handleJobClick = arg => {
    const job = arg
    setIsEdit(true)

    toggle()
  }

  const handleStatusFilterSelection = args => {
    //console.log(args)
    dispatch(setsListaIdStatus(args))
  }

  const onClickDelete = job => {
    setDeleteModal(true)
  }

  const handleDeletejob = () => {}

  const toggleViewModalAltaEstudiante = () =>
    setShowModalAltaEstudiante(!showModalAltaEstudiante)

  // #endregion

  // #region formik
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      jobId: (job && job.jobId) || "",
      jobTitle: (job && job.jobTitle) || "",
      companyName: (job && job.companyName) || "",
      location: (job && job.location) || "",
      experience: (job && job.experience) || "",
      position: (job && job.position) || "",
      type: (job && job.type) || "",
      status: (job && job.status) || "",
    },
    validationSchema: Yup.object({
      jobId: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, "Please Enter Valid Job Id")
        .required("Please Enter Your Job Id"),
      jobTitle: Yup.string().required("Please Enter Your Job Title"),
      companyName: Yup.string().required("Please Enter Your Company Name"),
      location: Yup.string().required("Please Enter Your Location"),
      experience: Yup.string().required("Please Enter Your Experience"),
      position: Yup.string().required("Please Enter Your Position"),
      type: Yup.string().required("Please Enter Your Type"),
      status: Yup.string().required("Please Enter Your Status"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateJobList = {
          id: job ? job.id : 0,
          jobId: values.jobId,
          jobTitle: values.jobTitle,
          companyName: values.companyName,
          location: values.location,
          experience: values.experience,
          position: values.position,
          type: values.type,
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values.status,
        }
        // update Job
        //dispatch(onUpdateJobList(updateJobList))
        validation.resetForm()
      } else {
        const newJobList = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          jobId: values["jobId"],
          jobTitle: values["jobTitle"],
          companyName: values["companyName"],
          location: values["location"],
          experience: values["experience"],
          position: values["position"],
          type: values["type"],
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values["status"],
        }
        // save new Job
        //dispatch(onAddNewJobList(newJobList))
        validation.resetForm()
      }
      toggle()
    },
  })

  const columns = useMemo(
    () => [
      {
        header: "id",
        accessorKey: "id_Alumno",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
        cell: cellProps => {
          return (
            <Link to="#" className="text-body fw-bold">
              {cellProps.row.original.id_Alumno}
            </Link>
          )
        },
      },
      {
        header: "Turno",
        accessorKey: "Nombre_Turno",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
      },
      {
        header: "Nombre",
        accessorKey: "apellidopaterno_apellido_materno_nombre",
        enableColumnFilter: false,
        enableSorting: true,
        size: 100,
      },
      {
        header: "Saldo",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "Balance",
        size: 50,
        cell: cellProps => {
          return (
            <Link
              to={`/caja`}
              onClick={() => {
                dispatch(
                  onSetCajaoAlumnoSelected({
                    id_Alumno: cellProps.row.original.id_Alumno,
                    Nombres:
                      cellProps.row.original
                        .apellidopaterno_apellido_materno_nombre,
                  })
                )
              }}
              className="text-body fw-bold"
            >
              ${cellProps.row.original.Balance?.toLocaleString()}
            </Link>
          )
        },
      },
      {
        header: "Promedio",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "Promedio",
        size: 20,
        cell: cellProps => {
          return `${
            cellProps.row.original.Promedio
              ? cellProps.row.original.Promedio.toFixed(2)
              : 0
          }`
        },
      },
      {
        header: "Avance",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "Avance",
        size: 50,
        cell: cellProps => {
          return `[${cellProps.row.original.Avance}]`
        },
      },
      // {
      //   header: "Type",
      //   accessorKey: "type",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: cellProps => {
      //     switch (cellProps.row.original.type) {
      //       case "Full Time":
      //         return <span className="badge badge-soft-success">Full Time</span>
      //       case "Part Time":
      //         return <span className="badge badge-soft-danger">Part Time</span>
      //       case "Freelance":
      //         return <span className="badge badge-soft-info">Freelance</span>
      //       default:
      //         return (
      //           <span className="badge badge-soft-warning">Internship</span>
      //         )
      //     }
      //   },
      // },
      // {
      //   header: "Posted Date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   accessorKey: "postedDate",
      // },
      // {
      //   header: "Last Date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   accessorKey: "lastDate",
      // },
      {
        header: "Status",
        accessorKey: "Nombre_Status",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
        cell: cellProps => {
          switch (cellProps.row.original.Nombre_Status) {
            case "Activo":
              return <Badge className="bg-success">Activo</Badge>
            case "Baja":
              return <Badge className="bg-danger">Baja</Badge>
            case "Titulado":
              return <Badge className="bg-success">Titulado</Badge>
            case "Suspendido":
              return <Badge className="bg-warning">Suspendido</Badge>
            case "Pasante":
              return <Badge className="bg-success">Pasante</Badge>
            case "Egresado":
              return <Badge className="bg-success">Egresado</Badge>
            case "Prospecto":
              return <Badge className="bg-success">Prospecto</Badge>
            case "Seguimiento":
              return <Badge className="bg-success">Seguimiento</Badge>
            case "ST Baja":
              return <Badge className="bg-success">ST Baja</Badge>
          }
        },
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        size: 50,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  onClick={() => {
                    console.log(cellProps.row.original)
                    setoAlumno(cellProps.row.original)
                    setModal(true)
                    setIsEdit(false)
                  }}
                  className="btn btn-sm btn-soft-primary"
                  id={`viewtooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-eye-outline" />
                </Link>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip-${cellProps.row.original.id}`}
              >
                Detalles
              </UncontrolledTooltip>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    console.log(cellProps.row.original)
                    setoAlumno(cellProps.row.original)
                    setModal(true)
                    setIsEdit(true)
                  }}
                  id={`edittooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-pencil-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`edittooltip-${cellProps.row.original.id}`}
                  >
                    Editar
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    const jobData = cellProps.row.original
                    onClickDelete(jobData)
                  }}
                  id={`deletetooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-delete-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id}`}
                  >
                    Baja
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        },
      },
    ],
    []
  )
  // #endregion

  // #region Options

  const statusOptions = [
    { text: "Activos & Suspendidos", value: "1,4" },
    { text: "Activos", value: "1" },
    { text: "Baja", value: "2" },
    { text: "Titulado", value: "3" },
    { text: "Suspendido", value: "4" },
    { text: "Pasante", value: "5" },
    { text: "Egresado", value: "6" },
    { text: "Prospecto", value: "7" },
    { text: "Seguimiento", value: "8" },
    { text: "ST Baja", value: "9" },
    { text: "Todos", value: "1,2,3,4,5,6,7,8,9" },
  ]

  // #endregion

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />

      {/* Alta Estudiante */}
      <Modal size="xl" isOpen={showModalAltaEstudiante} scrollable={true}>
        <AltaEstudiante onClose={toggleViewModalAltaEstudiante} />
      </Modal>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Control Escolar")}
            breadcrumbItem={props.t("Control Escolar")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <ToastContainer />
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title flex-grow-1">Alumnos</h5>
                    <div className="flex-shrink-0">
                      <Link
                        to="/control_escolar/alta_alumno"
                        // onClick={() => setShowModalAltaEstudiante(true)}
                        className="btn btn-primary me-1"
                      >
                        Agregar Alumno
                      </Link>
                      <Link
                        to="#!"
                        onClick={() => {
                          console.log("Click")
                          toast.success("Consulta exitosa", {
                            autoClose: 2000,
                          })
                        }}
                        className="btn btn-light me-1"
                      >
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                      <UncontrolledDropdown className="dropdown d-inline-block me-1">
                        <DropdownToggle
                          type="menu"
                          className="btn btn-success"
                          id="dropdownMenuButton1"
                        >
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <li>
                            <DropdownItem href="/control_escolar/alta_alumno">
                              /Alta_Alumno
                            </DropdownItem>
                          </li>
                          <li>
                            <DropdownItem href="#">Another action</DropdownItem>
                          </li>
                          <li>
                            <DropdownItem href="#">
                              Something else here
                            </DropdownItem>
                          </li>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {isLoading ? (
                    <Spinners setLoading={() => {}} />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={alumnos || []}
                      isCustomPageSize={false}
                      isGlobalFilter={true}
                      // divClassName="container"
                      //isAddButton={true}
                      buttonClass="btn btn-primary btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                      buttonName=" Add New Order"
                      handleUserClick={handleStatusFilterSelection}
                      isJobListGlobalFilter={true}
                      statusOptions={statusOptions}
                      isPagination={true}
                      SearchPlaceholder="Búsqueda ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      selectedValue={sListaIdStatus ? sListaIdStatus : "1,4"}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal size="xl" isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h5">
              {!!isEdit ? "Editar Estudiante" : "Consultar Estudiante"}
            </ModalHeader>
            <ModalBody>
              <DetallesModal oAlumno={oAlumno} isEdit={isEdit} />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

Control_Escolar.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Control_Escolar)
